
import { mapGetters } from 'vuex';
import { myBag,orderService } from '@/api/member/index';
import orderMethod from '@/utils/orderMethod';
import {
  checkpaypassword,
	getArtificerBySkuId,
	getOrderTime
} from "@/api/order/payment"
export default {
	name: 'order_list',
	components: {},
	data: () => {
		return {
			orderStatus: '1',
			loading: true,
			orderList: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			yes: true,
      backpackItem:{},
      cashierList:[],
			cashierId:'',
			cashierDateList:[],
      cashierChangeData:{},
			order_time:'選擇服務時間',
			order_date:'',
			dialogCashierTime:false,
      is_balance:0,
      password:'',
      dialogpay:false,
      artificerPrice:0,
			daysTimeIndex:0,
		};
	},
	mixins: [orderMethod],
	created() {
		this.orderStatus = this.$route.query.status || '1';
		this.getOrderList();
	},
  filters: {
		/**
		 * 金額格式化輸出
		 * @param {Object} money
		 */
		moneyFormat(money) {
      console.log('000',money,parseFloat(money).toFixed(2))
			return parseFloat(money).toFixed(2)
		},
	},
	computed: {
		...mapGetters(['defaultGoodsImage'])
	},
	mounted() {
		let self = this;
		setTimeout(function() {
			self.yes = false
		}, 300)
	},
	methods: {
    couponTap(item){
      console.log('item',item)
      this.backpackItem=item
      
      this.getArtificerList();
    },
    useBalance(type){
      if(type){
        this.artificerPrice=0
      }else{
        this.artificerPrice=this.cashierChangeData.artificer_price
      }
      this.is_balance=type
    },
    //獲取收營員列表
		getArtificerList(){
			getArtificerBySkuId({ sku_id: this.backpackItem.sku_id}).then(res => {
				if(res.code >=0&&res.data.list.length>0){
					this.cashierList=res.data.list
          this.dialogCashierTime=true
				}
			}).catch(err => {
				const {
					code,
					message,
					data
				} = err
				this.$message.error(message)
			})
		},
    //選擇收營員後觸發
		cashierChange(id){
			this.order_date=''
			this.order_time=''
      this.cashierDateList=[]
      this.cashierChangeData=this.cashierList.filter(item =>{return item.site_id == id})[0]
      this.artificerPrice=this.cashierChangeData.artificer_price
      console.log('cashierChangeData',this.cashierChangeData)
			getOrderTime({ site_id: id}).then(res => {
				if(res.code >=0&&res.data.length>0){
					this.cashierDateList=res.data
				}
			}).catch(err => {
				const {
					code,
					message,
					data
				} = err
				this.$message.error(message)
			})
		},
    timeClick(date,day,time,index){
			this.order_date=date+'-'+day
			this.order_time=time
			this.daysTimeIndex=index
		},
    cashierConfirm(){
      if(!this.order_date||!this.order_time){
        this.$message({
          message: "請選擇收銀員及時間",
          type: "warning"
        })
      }else{
        this.payOrderService();
        console.log('',this.order_date,this.order_time)
      } 
    },
    //提交
    payOrderService(){
      if(this.is_balance == '1'&&!this.password){ //余額支付
        this.dialogpay=true
        return
      }
      orderService({is_balance:this.is_balance,pay_password:this.password,order_date:this.order_date,order_time:this.order_time,artificer_id:this.cashierId,id:this.backpackItem.id}).then(res => {
        this.dialogCashierTime=false
        if(this.is_balance  == 0){
          this.$router.push({
            path: "/pay",
            query: {
              code: res.data
            }
          })
        }else{
          this.$router.push({
            path: "/result",
            query: {
              code: res.data
            }
          })
        }
      }).catch(err => {
        const {
          code,
          message,
          data
        } = err
        this.$message.error(message)
      })
    },
    /**
		 * 支付密碼輸入
		 */
		input() {
			if (this.password.length == 6) {
				var loading = this.$loading({
					lock: true,
					text: "支付中",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				})
				checkpaypassword({
						pay_password: this.password
					})
					.then(res => {
						const {
							code,
							message,
							data
						} = res
						loading.close()
						if (code >= 0) {
							this.dialogpay = false
              this.payOrderService();
              //this.dialogCashierTime=true
						} else {
							this.$message({
								message: message,
								type: "warning"
							})
						}
					})
					.catch(err => {
						loading.close()
						const {
							code,
							message,
							data
						} = err
						this.$message.error(message)
					})
			}
		},
    setPayPassword() {
			this.$router.pushToTab("/member/security");
		},
		handleClick(tab, event) {
			this.currentPage = 1;
			this.orderStatus = tab.name;
			this.refresh();
		},
		getOrderList() {
			myBag({
				page: this.currentPage,
				page_size: this.pageSize,
				status: this.orderStatus,
			})
				.then(res => {
					let list = [];
					if (res.code == 0 && res.data) {
						list = res.data.list;
						this.total = res.data.count;
					}
					this.orderList = list;
					this.loading = false;
				})
				.catch(res => {
					this.loading = false;
				});
		},
		handlePageSizeChange(size) {
			this.pageSize = size;
			this.refresh();
		},
		handleCurrentPageChange(page) {
			this.currentPage = page;
			this.refresh();
		},
		refresh() {
			this.loading = true;
			this.getOrderList();
		},
		imageError(orderIndex, goodsIndex) {
			this.orderList[orderIndex].order_goods[goodsIndex].sku_image = this.defaultGoodsImage;
		}
	}
};
